export enum QuestionTypes {
    QUESTION_TYPE_GROUP = 0,
    QUESTION_TYPE_SINGLE = 1,
    QUESTION_TYPE_MULTI = 2,
    QUESTION_TYPE_SELECT_OPTION = 3,
    QUESTION_TYPE_SHORT_ANSWER = 4,
    QUESTION_TYPE_DRAG_AND_DROP = 5,
    QUESTION_TYPE_SPEAK = 6,
    QUESTION_TYPE_LONG_ANSWER = 7,
    QUESTION_TYPE_LISTEN = 8
}

export interface Option {
    id?: string;
    uid?: string;
    title: string;
    isCorrect: number;
}

export interface InputField {
    label: string;
    type: string;
}

export interface BlankField {
    type: string;
    content?: string;
    answer?: string;
    correctAnswer?: string;
}

export interface SubQuestion extends Question {}

export interface Question {
    id?: string;
    parentId?: string;
    examId?: string;
    uid?: string;
    title: string;
    valueId?: string;
    value: string;
    displayIds?: string;
    type: QuestionTypes;
    required: boolean;
    answers?: Option[]; // Dùng cho SINGLE_CHOICE, MULTI_CHOICE, SELECT_OPTION
    correctAnswer?: number | number[] | string | null; // Hỗ trợ nhiều kiểu đáp án
    inputs?: InputField[]; // Dùng cho SHORT_ANSWER, LONG_ANSWER
    blanks?: BlankField[]; // Dùng cho DRAG_AND_DROP
    childs?: SubQuestion[]; // Dùng cho GROUP
    audioUrl?: string; // Dùng cho SPEAK (ghi âm)
    answerText?: string | null; // Dùng cho SHORT_ANSWER, LONG_ANSWER
}
